export default {
    mainContainer: {
        display: 'flex', 
        gap: '40px', 
        flexDirection: 'column', 
        marginTop: '70px', 
        alignItems: 'flex-start'
    },
    flexOne: {
        flex: 1
    },
    fontSize16: {
        fontSize: '16px'
    },
    settingGroup: {
        flex: 1,
        display: 'flex', 
        flexDirection: 'column', 
        gap: '10px'
    },
    fieldRow: { 
        display: 'flex', 
        gap: '20px', 
        alignItems: 'center'
    },
    fieldLabel: {
        fontSize: '14px', 
        whiteSpace: 'pre'
    },
    fieldMaxWidth: {
        maxWidth: '400px'
    },
    fullWidth: {
        width: '100%'
    },
     baseStyles: {
        display: 'inline-block',
        padding: '0.5rem 1rem',
        borderRadius: '5px',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: '#fff',
      },
    statusStyles: {
        Pending: { backgroundColor: '#f0ad4e' }, 
        Approved: { backgroundColor: '#5cb85c' }, 
        Rejected: { backgroundColor: '#d9534f' }, 
        Processing: { backgroundColor: '#5bc0de' }, 
      }
}